// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"493":"72a5830a","827":"67f3ab04","884":"78546ab5"}[chunkId] + ".chunk.js";
};